export type Platform = 'instagram' | 'tiktok' | 'youtube' | 'snapchat';
export type PlatformSlug = 'IG' | 'TT' | 'YT' | 'SC';

export type IGAge = '13-17' | '18-24' | '25-34' | '35-65+';
export type TikTokAge = '18-24' | '25-34' | '35-44' | '45-54' | '55+';
export type YouTubeAge = '13-24' | '25-34' | '35+';
export type SnapchatAge = '13-17' | '18-20' | '21-24' | '25-34' | '35+';

export type CriteriaProps = {
  label: string;
  value: number;
  display?: boolean;
};

export enum FILTERS {
  gender = 'gender',
  genderCriteria = 'genderCriteria',
  age = 'age',
  ageCriteria = 'ageCriteria',
  country = 'country',
  countryCriteria = 'countryCriteria',

  igFollowers = 'followers',
  igReachEngagementRate = 'avgFeedReachEngRate',
  igAverageFeedReach = 'avgFeedReach',
  igAverageStoryReach = 'avgStoryReach',
  igAverageReelsViews = 'avgReelsPlays',

  ttFollowers = 'followers',
  ttAverageViews = 'avgViews',
  ttAverageEngagementRate = 'avgEngRate',

  ytFollowers = 'followers',
  ytAverageViews = 'avgViews',
  ytAverageEngagementRate = 'avgEngRate',

  scFollowers = 'followers',
}

export type IGFilters = {
  [FILTERS.gender]: 'Male' | 'Female';
  [FILTERS.genderCriteria]: number;
  [FILTERS.age]: IGAge;
  [FILTERS.ageCriteria]: number;
  [FILTERS.country]: string;
  [FILTERS.countryCriteria]: number;
  [FILTERS.igFollowers]: number;
  [FILTERS.igReachEngagementRate]: number;
  [FILTERS.igAverageFeedReach]: number;
  [FILTERS.igAverageStoryReach]: number;
  [FILTERS.igAverageReelsViews]: number;
};

export type TikTokFilters = {
  [FILTERS.gender]: 'Male' | 'Female' | 'Other';
  [FILTERS.genderCriteria]: number;
  [FILTERS.age]: TikTokAge;
  [FILTERS.ageCriteria]: number;
  [FILTERS.country]: string;
  [FILTERS.countryCriteria]: number;
  [FILTERS.ttFollowers]: number;
  [FILTERS.ttAverageViews]: number;
  [FILTERS.ttAverageEngagementRate]: number;
};

export type YouTubeFilters = {
  [FILTERS.gender]: 'Male' | 'Female';
  [FILTERS.genderCriteria]: number;
  [FILTERS.age]: YouTubeAge;
  [FILTERS.ageCriteria]: number;
  [FILTERS.country]: string;
  [FILTERS.countryCriteria]: number;
  [FILTERS.ytFollowers]: number;
  [FILTERS.ytAverageViews]: number;
  [FILTERS.ytAverageEngagementRate]: number;
};

export type SnapchatFilters = {
  [FILTERS.gender]: 'Male' | 'Female' | 'Unknown';
  [FILTERS.genderCriteria]: number;
  [FILTERS.age]: SnapchatAge;
  [FILTERS.ageCriteria]: number;
  [FILTERS.country]: string;
  [FILTERS.countryCriteria]: number;
  [FILTERS.scFollowers]: number;
};

export type FilterMap = {
  [K in Platform]: K extends 'instagram'
    ? IGFilters
    : K extends 'tiktok'
      ? TikTokFilters
      : K extends 'youtube'
        ? YouTubeFilters
        : K extends 'snapchat'
          ? SnapchatFilters
          : never;
};

export type Filters<P extends Platform = Platform> = {
  platform: P;
  filterType: keyof FilterMap[P];
  value: FilterMap[P][keyof FilterMap[P]];
};
